




































































































import { Component ,Prop} from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { QueryNoManagedList,GetDiseaseTypes } from "@/api/pdReferral";
import SetCommunity from "./setCommunity.vue";
import SetTeam from "./setTeam.vue";
import SetDoctor from "./setDoctor.vue";
import PdOutPatientMain from "@/views/pdOutPatient/pdOutPatientIndex/main.vue";
import PdChartAssayTrend from "@/views/electronicMedicalRecord/patient/parts/assayResult/detailed.vue";
import util from "@/lib/util";
import ajax from "axios";
import {
  SavePdPatientBringinto,
  BatchPdPatientBringinto
} from "@/api/pdOutPatient/pdBasicInformation";

/**
 * 待管理的患者
 */
@Component({
  components: {
    PdOutPatientMain,
    SetCommunity,
    SetTeam,
    SetDoctor,
    PdChartAssayTrend,
  },
})
export default class NoManagedPatients extends AbpBase {
  @Prop({ type: Object, default: {} }) queryData: any;
  data: any[] = [];
  currentPatient: any = {};
  loading: boolean = false;
  showPatientDetail: boolean = false;
  showCommunity: boolean = false;
  showTeam: boolean = false;
  showDoctor: boolean = false;
  tableTotalSize: number = 0;
  showCondition: boolean = false;
  chartData: any = {};
  showChartAssay: boolean = false;
  DiseaseTypes: any[] = [];
  DiseaseType: string = "";
  queryCondition: any = {
    QueryString: this.queryData?this.queryData.QueryString:"",
    isManaged:"未纳入需管理",
    Page: 1,
    PageSize: 10,
    name: "",
    sexName: "",
    birthday: null,
    ageStart: null,
    ageEnd: null,
    cid: "",
    address: "",
    patientCard: "",
    ckdEpiStart: null,
    ckdEpiEnd: null,
    ckd: null,
    urineProtein: null,
    rbcStart: null,
    rbcEnd: null,
    acrStart: null,
    acrEnd: null,
    ExamCenter:false,
    patientType:"",
  };
  styles = {
    height: "calc(100% - 55px)",
    overflow: "auto",
    paddingBottom: "53px",
    position: "static",
  };
  columns = [
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      key: "pick",
    },
    {
      title: "姓名",
      width: 100,
      fixed: "left",
      key: "name",
    },
    {
      title: "身份证号",
      width: 200,
      key: "cid",
    },
    {
      title: "医保卡号",
      minWidth: 180,
      key: "patientCard",
    },
    {
      title: "性别",
      width: 80,
      key: "sexName",
    },
    // {
    //   title: "出生日期",
    //   width: 160,
    //   key: "birthday",
    //   render: (h: any, p: any) => {
    //     return h("span", {}, this.fmtDate(new Date(p.row.birthday), "yyyy年MM月dd日"));
    //   }
    // },
    {
      title: "年龄",
      width: 80,
      key: "age",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.age + "岁");
      },
    },
    {
      title: "手机号",
      width: 160,
      key: "phone",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.phone );
      },
    },
    {
      title: "胸部CT",
      width: 100,
      key: "hasChestCTName",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.hasChestCTName );
      },
    },
    {
      title: "患者类型",
      width: 120,
      key: "patientType",
    },
    {
      title: "就诊科室",
      width: 120,
      key: "deptName",
    },
    {
      title: "尿白蛋白",
      width: 120,
      key: "urineProtein",
    },
    {
      title: "尿红细胞",
      width: 120,
      key: "rbc",
      render: (h: any, p: any) => {
        if (p.row.rbc != null) {
          return h("div", [
            h("span", p.row.rbc),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "600092",
                    itemName: "尿红细胞",
                    unit: "/uL",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "尿ACR",
      width: 120,
      key: "acr",
      render: (h: any, p: any) => {
        if (p.row.acr != null) {
          return h("div", [
            h("span", p.row.acr),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "60501",
                    itemName: "尿ACR",
                    unit: "mg/g",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "肌酐",
      width: 120,
      key: "crea",
      render: (h: any, p: any) => {
        if (p.row.crea != null) {
          return h("div", [
            h("span", p.row.crea),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "2024",
                    itemName: "肌酐",
                    unit: "umol/L",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "eGFR",
      width: 120,
      key: "ckdEpi",
      render: (h: any, p: any) => {
        if (p.row.ckdEpi != null) {
          return h("div", [
            h("span", p.row.ckdEpi),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "1113",
                    itemName: "eGFR",
                    unit: "",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "CKD分期",
      width: 110,
      key: "ckd",
      render: (h: any, p: any) => {
        if (p.row.ckd) {
          let props: any = {};
          switch (p.row.ckd) {
            case "G1":
              props.color = "blue";
              break;
            case "G2":
              props.color = "cyan";
              break;
            case "G3a":
              props.color = "red";
              break;
            case "G3b":
              props.color = "#FFA2D3";
              break;
            case "G4":
              props.color = "warning";
              break;
            case "G5":
              props.color = "error";
              break;
          }
          return h("Tag", { props: props }, p.row.ckd + " 期");
        }
      },
    },
    {
      title: "建议随访次数",
      width: 150,
      key: "followTimes",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.followTimes + "次/年");
      },
    },
    {
      title: "最后检验时间",
      width: 150,
      key: "lastReportTime",
      render: (h1: any, p: any) => {
        let h = this.$createElement
        return h("span", this.formatDate(p.row.lastReportTime));
      },
    },
    {
      key: "",
      width: 310,
      fixed: "right",
      title: "操作",
      render: (h: any, p: any) => {
        let buttons = [];
        buttons.push(
          h(
            "Button",
            {
              props: { type: "primary", size: "small" },
              on: {
                click: () => {
                  this.basicInfo(p.row);
                },
              },
            },
            "编辑"
          )
        );
        if(!p.row.isManaged){
          buttons.push(
            h(
              "Button",
              {
                props: { type: "primary", size: "small" },
                style: { marginLeft: "10px" },
                on: {
                  click: () => {
                    this.bringinto(p.row);
                  },
                },
              },
              "纳入需管理"
            )
          );
        }
        if (this.PatientListHISButonShow) {
          buttons.push(
            h(
              "Button",
              {
                props: { type: "info", size: "small" },
                style: { marginLeft: "10px" },
                on: {
                  click: () => {
                    this.showEmr(p.row);
                  },
                },
              },
              this.PatientListHISNameChange
            )
          );
        }

        return h("div", buttons);
      },
    },
  ];

  get PatientListHISButonShow() {
    return util.abp.setting.get("PatientListHISButonShow") == "1";
  }
  get NoManagedOrderByNo() {
    return util.abp.setting.get("NoManagedOrderByNo") == "1";
  }
  get defaultDiseaseType() {
    return util.abp.setting.get("defaultDiseaseType");
  }
  get PatientListHISNameChange() {
    return util.abp.setting.get("PatientListHISNameChange");
  }

  get PatientListHISType() {
    return util.abp.setting.get("PatientListHISType");
  }

  get Needtomanagebackgroundcolor() {
    return util.abp.setting.get("Needtomanagebackgroundcolor");
  }

  // 显示His电子病历视图
  showEmr(row: any) {
    let url = `${SYNC_EMR_URL}?patientId=${row.id}&userCode=${this.$store.state.session.user.userName}`;
    ajax
      .get(url, { timeout: 60000 })
      .then((res: any) => {
        this.$Loading.finish();
        if (res.data.code === 2000) {
          switch (this.PatientListHISType) {
            case "0":
              let emrUrl = res.data.data;
              window.open(emrUrl);
              break;
            case "1":
              this.openExe(res.data.data);
              break;
          }
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.$Loading.error();
        this.$Modal.error({
          title: "提示",
          content: "读取患者电子病历视图地址时出现错误",
        });
      });
  }

  // 打开本地客户端上的exe程序
  // 使用说明见源码目录openExe目录下
  openExe(paras: string) {
    try {
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = `openExe:${paras}`;
      console.log(a.href);
      a.click();
    } catch (error) {
      console.log(error);
      alert("客户端程序打开异常，请联系工程师处理。");
    }
  }

  created() {
    this.initDic();
     let user = this.$store.state.session.user;
    if (user) {
      this.DiseaseType=user.diseaseType;
    }
    this.DiseaseType=this.DiseaseType?this.DiseaseType:this.defaultDiseaseType;
  }
  
  async initDic() {
    let res1 = await GetDiseaseTypes();
    this.DiseaseTypes = res1;
    this.getData();
  }
  pageChange(val: any) {
    this.queryCondition.Page = val;
    this.getData();
  }

  async getData() {
    this.loading = true;
    
    this.queryCondition.DiseaseType = this.DiseaseType;
    let res = await QueryNoManagedList(this.queryCondition);
    this.data = res.items;
    this.tableTotalSize = res.totalCount;
    this.loading = false;
  }

  //基本信息
  basicInfo(row: any) {
    this.currentPatient = row;
    this.currentPatient.pD_Patient_ID = row.id;
    this.showPatientDetail = true;
  }
  async bringinto(row: any) {
    this.$confirm("确定"+row.name+"("+row.cid+")要纳入需管理吗？", "提示").then(() => {
      this.loading = true;
      SavePdPatientBringinto(row).then(res => {
        this.getData();
      });
      this.loading = false;
    });
  }
  handleResetCondition() {
    this.queryCondition.name = "";
    this.queryCondition.sexName = "";
    this.queryCondition.cid = "";
    this.queryCondition.patientCard = "";
    this.queryCondition.ckd = null;
    this.queryCondition.ckdEpiStart = null;
    this.queryCondition.ckdEpiEnd = null;
    this.queryCondition.ageStart = null;
    this.queryCondition.ageEnd = null;
    this.queryCondition.urineProtein = null;
    this.queryCondition.rbcStart = null;
    this.queryCondition.rbcEnd = null;
    this.queryCondition.acrStart = null;
    this.queryCondition.acrEnd = null;
    this.queryCondition.creaStart = null;
    this.queryCondition.creaEnd = null;
  }

  handleQuery() {
    this.showCondition = true;
  }

  handleBringinto() {
    let patList = this.$refs.table1.getSelection();
    let bringList =patList.filter((x:any)=>x.isManaged==false);
    if(bringList.length>0){
   this.$confirm("确定要批量将这些患者纳入需管理吗？", "提示").then(() => {
     this.loading = true;
     BatchPdPatientBringinto(bringList).then(res => {
       this.getData();
     });
     this.loading = false;
   });
  }
  }

  handleQuerySubmit() {
    this.showCondition = false;
    this.queryCondition.Page = 1;
    this.$nextTick(() => {
      this.$refs["pages"].currentPage = 1;
    });
    this.getData();
  }

  //显示指标趋势图
  showChart(row: any) {
    this.chartData = {
      pD_Patient_ID: row.pD_Patient_ID,
      itemCode: row.itemCode,
      itemName: row.itemName,
      unit: row.unit,
    };
    this.showChartAssay = true;
  }
  rowClassName(row, index) {
      if (row.isManaged && this.Needtomanagebackgroundcolor) {
          return 'electronic-patient-table-info-'+this.Needtomanagebackgroundcolor+'-row';
      } else{
          return '';
      }
      return '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/noManaged.vue